import axios from "axios";
import { generateUrl, getToken, removeToken } from "../helper";
import { validateLogin } from "../../redux/action";
import { store } from "../../redux/store";
import { encryptPasswordFields } from "../encryption";

const skills = axios.create({
  baseURL: generateUrl("skills_backend"),
});
skills.interceptors.request.use(
  function (config) {
    let token = getToken();
    if (token && token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Encrypt password fields in request body
    if (config.data) {
      config.data = encryptPasswordFields(config.data);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
skills.interceptors.response.use(
  (response) => {
    store.dispatch(validateLogin(true));
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      removeToken();
      window.location.href = "/login";
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);
export default skills;
